import { render, staticRenderFns } from "./TelOrderModifyModal.vue?vue&type=template&id=2a75ea6e"
import script from "./TelOrderModifyModal.vue?vue&type=script&lang=js"
export * from "./TelOrderModifyModal.vue?vue&type=script&lang=js"
import style0 from "./TelOrderModifyModal.vue?vue&type=style&index=0&id=2a75ea6e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports